module.exports = __webpack_public_path__ + "static/media/pousada_1.91158ed2.jpg";